import useWidth from '@components/Hooks/useWidth';
import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { ElementType, MouseEvent, forwardRef } from 'react';

interface FilterButtonProps {
  label: string;
  icon: ElementType;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  testId?: string;
  isActive?: boolean;
}

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ label, icon, onClick, testId, isActive }, ref) => {
    const { mediumDownWidth } = useWidth();

    if (mediumDownWidth) {
      return (
        <IconButton
          ref={ref}
          color="secondary"
          icon={icon}
          onClick={onClick}
          testId={testId}
          ariaLabel={label}
          isActive={isActive}
          sx={(theme) => ({ borderRadius: theme.shape.borderRadiusFull })}
        />
      );
    }

    return (
      <Button
        size="medium"
        variant="contained"
        color="secondary"
        ref={ref}
        onClick={onClick}
        testId={testId}
        isActive={isActive}
        startIcon={<Icon icon={icon} />}
      >
        {label}
      </Button>
    );
  },
);

FilterButton.displayName = 'FilterButton';
export default FilterButton;
